import React from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeUser } from './userSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { isUserAdmin } from '../../services/authenticationService';

export default function UserList() {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditUser } = React.useContext(CommonContext) as CommonContextType;
  const Users = useSelector(
    (state: AppState) => state.Users
  );
  const showModal = (record?: any) => {
    if (record.id) {
      setEditUser(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeUser(id));
    /* messageApi.open({
      type: 'success',
      content: 'User deleted successfully',
    }); */
  };

  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={Users}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={isUserAdmin() ?
            [<EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>] : []}>

          <div className='main_class'>
            <span className='heading'>{item.user_name} </span> ({item.user_role})
            <p className='sub_data'><b>SGID:</b> {item.user_sgid} <span className="tab"></span><b>Email:</b> {item.user_email}<br />{item.created_datetime}</p>
          </div>
        </List.Item>
      )}
    />
  );
}